/**
 * Portal — Unveil's front page. Two ways in: Code or Occult.
 */

let handlers = { onEnterSide: () => {} };
let rootEl;

function render() {
  rootEl.innerHTML = `
    <div class="portal__inner">
      <p class="portal__mark" aria-hidden="true">◇ ◆ ◇</p>
      <h1 class="portal__title">Unveil</h1>
      <p class="portal__tagline">Nothing stays hidden</p>
      <div class="portal__divider" aria-hidden="true"><span>◇ ◆ ◇</span></div>
      <nav class="portal__sides" aria-label="Choose a side">
        <a class="portal__side" href="/code" data-side="code">Code</a>
        <a class="portal__side" href="/occult" data-side="occult">Occult</a>
      </nav>
    </div>`;

  rootEl.addEventListener('click', (e) => {
    const side = e.target.closest('[data-side]');
    if (!side) return;
    e.preventDefault();
    handlers.onEnterSide(side.dataset.side);
  });
}

export function initPortal(opts) {
  handlers = { ...handlers, ...opts };
  rootEl = document.getElementById('portal');
  render();
}
